import { useTheme } from "@material-ui/core";
import React, { CSSProperties } from "react";
import Section, { SectionProps } from "./Section";

const Question = (props: {
  children: React.ReactChild | React.ReactChild[];
  spacing?: number;
  section?: boolean;
  sectionProps?: SectionProps;
  showIf?: boolean;
  style?: CSSProperties;
}) => {
  const theme = useTheme();
  const spacing = props.spacing ?? 2;
  const section = props.section ?? false;
  const showIf = props.showIf ?? true;

  const style: CSSProperties = props.style ?? {
    display: "grid",
    marginTop: theme.spacing(spacing),
    gridGap: theme.spacing(spacing),
    alignContent:"start",
    alignItems:"start"
  };

  if (!section) {
    return <>{showIf && <div style={style}>{props.children}</div>}</>;
  } else {
    return (
      <>
        {showIf && (
          <Section {...props.sectionProps}>
            <div style={style}>{props.children}</div>
          </Section>
        )}
      </>
    );
  }
};

export default Question;
